import { getBuildType } from '@/core/utils/buildType'

export const getThemeStorageKey = (): string => {
	const buildType = getBuildType()

	return `theme:${buildType}`
}
